<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-form ref="form" v-bind="this.$attrs">
        <v-row>
          <v-col cols="12" :md="isTeacherFilterShown ? 4 : 8">
            <GradeClassStudentSelect
              :gradeCol="{ cols: 12, md: isTeacherFilterShown ? 12 : 6 }"
              :classCol="{ cols: 12, md: 6 }"
              disableStudentSelect
              :disableClassSelect="isTeacherFilterShown"
              @changed="gradeClassChange"
            />
          </v-col>
          <v-col cols="12" md="4" v-if="isTeacherFilterShown">
            <AutocompleteTeacherCard
              :syncedValue.sync="teacher"
              item-text="name"
              clear-icon="mdi-close"
              label="Giáo viên"
              outlined
              dense
              deletable-chips
              hide-details
              :displaySubjectGroup="true"
              :filter="teacherFilter"
              :disabled="isTeacherFilterDisabled"
            />
          </v-col>
          <v-col cols="12" md="4">
            <DateIOSPicker
              label="Ngày"
              :date.sync="datetime"
              outlined
              :rules="[$rules.date, $rules.dateFromNow]"
              dense
            />
          </v-col>
        </v-row>
      </v-form>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" @click="onFilterChanged" outlined :disabled="isFormValidated"> Tìm kiếm </v-btn>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash'
import moment from 'moment'
import GradeClassStudentSelect from '../../components/basic/filter/GradeClassStudentSelect.vue'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker'
import AutocompleteTeacherCard from '@/components/basic/input/AutocompleteTeacherCard'

export default {
  components: {
    GradeClassStudentSelect,
    DateIOSPicker,
    AutocompleteTeacherCard,
  },
  data: () => ({
    selectedGrade: {},
    selectedClass: {},
    teacher: null,
    datetime: moment().toISOString(),
    isTeacherFilterShown: false,
  }),
  mounted() {
    const hash = this.$route.hash
    if (hash === '#teacher') {
      this.isTeacherFilterShown = true
    }
  },
  methods: {
    gradeClassChange(data) {
      if (get(this.selectedGrade, 'academicLevel') !== get(data.grade, 'academicLevel')) {
        this.selectedClass = {}
      }
      this.selectedGrade = { ...data.grade }
      this.selectedClass = { ...data.class }
    },
    onFilterChanged() {
      if (!this.$refs.form.validate()) return

      this.$emit('onFilterChanged', this.getFilterData())
    },
    getFilterData() {
      const result = {
        grade: get(this.selectedGrade, 'id'),
        class: get(this.selectedClass, 'id'),
        date: this.datetime,
      }
      if (this.isTeacherFilterShown) result['teacher'] = get(this.teacher, 'id')
      return result
    },
  },
  computed: {
    isFormValidated() {
      const data = this.getFilterData()
      return Object.values(data).filter(Boolean).length < 3
    },
    teacherFilter() {
      if (this.selectedGrade) {
        return { academicLevels_in: get(this.selectedGrade, 'academicLevel') }
      }
      return {}
    },
    isTeacherFilterDisabled() {
      const grade = get(this.selectedGrade, 'id')
      if (grade) return false
      return true
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
